import React, { useEffect, useRef, useState } from 'react';

import { Assets } from '../../../../../utils/assets';
import { InformationCard } from '../InformationCard';
import * as S from './InformationSection.styles';

const Sections = [
  {
    description: 'Experience our full library of scientifically engineered music, designed to help you focus, relax, meditate, or sleep—whenever you need it.',
    highlightedTitle: 'Access to all ',
    imageSrc: Assets.images.downloadAccessToAll.url,
    remainingTitle: 'of Brain.fm’s Science-Backed Music',
  },
  {
    description: 'Manage your entire Brain.fm experience effortlessly right from your macOS menu bar. <br /> <br /> Start, stop and view your session timer without every leaving your workflow, ensuring uninterrupted focus and productivity.',
    highlightedTitle: 'Seamless Control <br />',
    imageSrc: Assets.images.downloadSeamlessControl.url,
    remainingTitle: 'Directly in Your Menu Bar',
  },
  {
    description: 'Enjoy Brain.fm distraction-free. With our desktop app, your music is always within reach without the hassle of searching through tabs in your browser.',
    highlightedTitle: 'No More Juggling <br />',
    imageSrc: Assets.images.downloadNoMoreJuggling.url,
    remainingTitle: 'Browser Tabs',
  },
  {
    description: 'Quickly access and manage your library of favorite music in mere seconds.',
    highlightedTitle: 'Easy Access ',
    imageSrc: Assets.images.downloadEasyAccess.url,
    remainingTitle: 'To Your Favorite Tracks',
  },
  {
    description: 'Discover new tracks based on your mood, genre preferences, and mental state. <br /> <br /> Stay up to date with the latest music releases tailored to your needs.',
    highlightedTitle: 'Explore New ',
    imageSrc: Assets.images.downloadExploreNew.url,
    remainingTitle: 'and Personalized Music',
  },
]

export const InformationSection = () => {
  const [activeSection, setActiveSection] = useState(Sections[0]);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const observerRef = useRef<(HTMLImageElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = observerRef.current.indexOf(entry.target as HTMLImageElement);
          if (index !== -1) {
            setIsVisible(false);
            setTimeout(() => {
              setActiveSection(Sections[index]);
              setIsVisible(true);
            }, 300); 
          }
        }
      });
    }, { threshold: 0.3 });


    const currentObserverRef = observerRef.current;

    currentObserverRef.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      currentObserverRef.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <S.Container>
      <S.BlurContainer>
        <S.BlurImage src={Assets.images.downloadBlur1.url} />
        <S.BlurImage2 src={Assets.images.downloadBlur2.url}  />
        <S.BlurImage3 src={Assets.images.downloadBlur3.url}  />
        <S.BlurImage4 src={Assets.images.downloadBlur4.url}  />
      </S.BlurContainer>
      <S.MainContainer>
        <S.TextContainer isVisible={isVisible}>
          <S.Title>
            <S.HighlightedTitle dangerouslySetInnerHTML={{ __html: activeSection.highlightedTitle }} />
            <S.RemainingTitle dangerouslySetInnerHTML={{ __html: activeSection.remainingTitle }} />
          </S.Title>
          <S.Description dangerouslySetInnerHTML={{ __html: activeSection.description }} />
        </S.TextContainer>
        <S.ContentContainer>
          <S.ImagesSection>
            {Sections.map((section, index) => (
              <S.Image
                key={index}
                ref={(el) => {
                  observerRef.current[index] = el;
                }}
                src={section.imageSrc}
              />
            ))}
          </S.ImagesSection>
        </S.ContentContainer>
      </S.MainContainer>
      <S.MobileContainer>
        {Sections.map((section, index) => (
          <InformationCard
            key={index}
            description={section.description}
            highlightedTitle={section.highlightedTitle}
            imageSrc={section.imageSrc}
            remainingTitle={section.remainingTitle}
          />
        ))}
      </S.MobileContainer>
    </S.Container>
  );
};